import { render } from "./CloudflareImagePreview.vue?vue&type=template&id=1070931a&scoped=true"
import script from "./CloudflareImagePreview.vue?vue&type=script&lang=js"
export * from "./CloudflareImagePreview.vue?vue&type=script&lang=js"

import "./CloudflareImagePreview.vue?vue&type=style&index=0&id=1070931a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1070931a"]])

export default __exports__